"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CademyError = void 0;
const Path_1 = __importDefault(require("../Path"));
const DOMAIN = 'https://errors.cademy.io';
const isWebsafeError = (error) => {
    return (error instanceof Object &&
        'safe' in error &&
        (typeof error.safe === 'string' || Array.isArray(error.safe)));
};
const isProblemDetails = (error) => {
    return (error instanceof Object &&
        'type' in error &&
        typeof error.type === 'string' &&
        'title' in error &&
        typeof error.title === 'string');
};
/**
 * @see https://www.rfc-editor.org/rfc/rfc7807
 */
class CademyError extends Error {
    /**
     *
     * @param dirtyType A URI reference that identifies the problem type.
     * @param title A short, human-readable summary of the problem type. It SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization.
     * @param detail A human-readable explanation specific to this occurrence of the problem.
     * @param status The HTTP status code.
     * @param instance A URI reference that identifies the specific occurrence of the problem.
     */
    constructor(dirtyType, title, detail, status, instance, extensions) {
        super(detail !== null && detail !== void 0 ? detail : title);
        this.title = title;
        this.detail = detail;
        this.status = status;
        this.instance = instance;
        this.extensions = extensions;
        this.cleanType = new Path_1.default(dirtyType.toLowerCase());
        this.name = this.cleanType.withoutLeadingSlash;
    }
    get type() {
        return `${DOMAIN}${this.cleanType.value}`;
    }
    toObject() {
        return Object.assign({ type: this.type, title: this.title, detail: this.detail, status: this.status, instance: this.instance }, this.extensions);
    }
    static fromObject(members) {
        const { type, title, detail, status, instance } = members, extensions = __rest(members, ["type", "title", "detail", "status", "instance"]);
        return new this(type.replace(DOMAIN, ''), title, detail, status, instance, extensions);
    }
    toJSON() {
        return this.toObject();
    }
    static fromJSON(json) {
        return this.fromObject(JSON.parse(json));
    }
    static fromUnknown(error, fallbackError) {
        var _a, _b;
        if (error instanceof CademyError) {
            return error;
        }
        if (isProblemDetails(error)) {
            return CademyError.fromObject(error);
        }
        if (isWebsafeError(error)) {
            if (Array.isArray(error.safe)) {
                return new CademyError('/unknown-error', error.safe.join(', '), undefined, (_a = error.statusCode) !== null && _a !== void 0 ? _a : 500);
            }
            else {
                return new CademyError('/unknown-error', error.safe, undefined, (_b = error.statusCode) !== null && _b !== void 0 ? _b : 500);
            }
        }
        if (fallbackError) {
            return fallbackError;
        }
        return new CademyError('/unknown-error', 'Unknown error', 'An unknown error occurred, please try again or contact support', 500);
    }
}
exports.CademyError = CademyError;
exports.default = CademyError;
